/**
 * Get the current training mode status from localStorage
 */
export const isTrainingMode = () => {
  try {
    const value = localStorage.getItem('isTrainingMode');
    if (value === null) return false;
    return JSON.parse(value);
  } catch (error) {
    console.error('Error parsing isTrainingMode from localStorage:', error);
    return false;
  }
};

/**
 * Set the training mode status in localStorage
 */
export const setTrainingMode = (value) => {
  try {
    localStorage.setItem('isTrainingMode', JSON.stringify(value));
  } catch (error) {
    console.error('Error setting isTrainingMode in localStorage:', error);
  }
};

